<template>
    <a class="btn btn-default btn-block btn-property"
       :class="{'active': value == property.propertyId}"
       @click="selectProperty()">
        <img :src="imgUrl" alt="branding">
        <span class="property-label"><slot></slot></span>
        <span class="surcharge">+ {{property.property.surcharge | currency}}</span>
    </a>
</template>

<script>
    export default {
        props: {
            value: Number,
            property: Object,
            imgUrl: String
        },
        data() {
            return {
            }
        },
        methods: {
            selectProperty() {
                this.$emit('input', this.property.propertyId);
            }
        }
    }
</script>

<style scoped>
    .btn-property {
        min-height: 38px;
        line-height: 19px;
        background-color: transparent;
        border: 1px solid #7b736b;
        box-shadow: none;
        text-align: left;
        padding-left: 45px;
        padding-right: 0;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .btn-property img {
        position: absolute;
        top: 0;
        left: 0;
        height: 38px;
    }

    .btn-property .property-label{
        height: 19px;
        line-height: 12px;
        font-size: 12px;
        vertical-align: middle;
        overflow: hidden;
        display: block;
    }

    /*.btn-property:after {
        content: "";
        height: 53px;
        width: 55px;
        border: 1px solid #7b736b;
        position: absolute;
        top: 0px;
        left: -1px;
        background-position: center center;
        -webkit-background-size: contain;
        background-size: contain;
        /*noinspection CssUnresolvedCustomProperty
    }*/

    span.surcharge {
        position: absolute;
        right: 3px;
        bottom: 3px;
        font-size: 10px;
        line-height: 11px;
    }

    .btn-property.active {
        border: 2px solid #7b736b;
        padding-top: 6px;
        padding-left: 44px;
    }
    .btn-property.active img {
       top: -1px;
       left: -1px;
    }
    .btn-property.active span.surcharge {
        right: 2px;
        bottom: 2px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ShoppingWizardSelectionButton.vue